import { router } from "../router";
import { isSameLocation } from "./sameLocation";

// A navigation to the URL we are already on is meaningless, but the v7 data
// router does not treat it as a no-op: router.navigate(currentUrl) still pushes
// a fresh history entry (new key) and fires router.subscribe, which dispatches
// ROUTE_CHANGED and re-renders every RouteElement. Editor flows constantly
// re-assert the current URL (e.g. modifyQuery dropping a param that isn't
// present rebuilds the identical pathname+search+hash), so without this guard
// those calls feed back into a render -> push -> ROUTE_CHANGED loop and React
// aborts with "Maximum update depth exceeded". connected-react-router made
// same-location pushes inert; this restores that invariant.
//
// RouteElement's history.push/replace share the same check (via isSameLocation)
// so route-prop navigations aren't a second, unguarded entry point.
const isCurrentLocation = (to: unknown): boolean =>
  isSameLocation(to, router.state.location);

export const navigate = (to: any, options?: { replace?: boolean }) => {
  if (isCurrentLocation(to)) return;
  return router.navigate(to, options);
};

export const navigateAction = (to: any, options?: { replace?: boolean }) => {
  const action = () => {
    if (isCurrentLocation(to)) return;
    return router.navigate(to, options);
  };
  (action as any).type = "ROUTER_NAVIGATE";
  (action as any).payload = {
    method: options?.replace ? "replace" : "push",
    args: [to]
  };
  return action;
};
